import {get, post} from "@services/request";
import React from "react";
export type RequestBody = {
    supplier: string,
    contentLanguage: string,
    hotels: string[] | undefined | null
}


export interface AuditHistory  {
    key?: React.Key;
    reportName : string;
    orderNumber: string;
    fileName: string;
    requester: string
    requestedAt: string;
    supplier: string;
    status:string;
}

export type languageType = {
    key: string;
    label: string;
};
export const languages: languageType[] = [
    {
        key: 'EN-US',
        label: 'English - English(US)',
    },
    {
        key: 'EN-GB',
        label: 'English - English (UK)',
    },
    {
        key: 'DE-DE',
        label: 'German - Deutsch',
    },
    {
        key: 'ES-ES',
        label: 'Spanish - Español(ES)',
    },
    {
        key: 'ES-MX',
        label: 'Spanish - Español(MX)',
    },
    {
        key: 'ES-AR',
        label: 'Spanish - Español(AR)',
    },
    {
        key: 'FR-FR',
        label: 'French - Français',
    },
    {
        key: 'IT-IT',
        label: 'Italian - Italiano',
    },
    {
        key: 'PT-PT',
        label: 'Portuguese - Português (PT)',
    },
    {
        key: 'RU-RU',
        label: 'Russian - Русский',
    },
    {
        key: 'JA-JP',
        label: 'Japanese - 日本語',
    },
    {
        key: 'ZH-CN',
        label: 'Simplified Chinese - 简体中文',
    },
    {
        key: 'KO-KR',
        label: 'Korean - 한국어',
    },
    {
        key: 'TR-TR',
        label: 'Turkish - Türkçe',
    },
    {
        key: 'AR-AE',
        label: 'Arabic - المملكة العربية السعودية - العربية',
    },
    {
        key: 'IW-IL',
        label: 'Hebrew - עברית',
    },
    {
        key: 'PT-BR',
        label: 'Portuguese - Português(BR)',
    },
    {
        key: 'NL-NL',
        label: 'Dutch - Nederlands',
    },
    {
        key: 'ZH-TW',
        label: 'Traditional Chinese - 繁體中文',
    },
    {
        key: 'PL-PL',
        label: 'Polish - Polski',
    },
    {
        key: 'ID-ID',
        label: 'Indonesian - Bahasa Indonesia',
    },
    {
        key: 'TH-TH',
        label: 'Thai - ภาษาไทย',
    },
]
export const getAllHotelCodes = (supplier: string) => get(`/reports/audit/hotelcodes?supplier=${supplier}`)
export const generateReport = (body : RequestBody) => post('/reports/audit', body)

